<template>
  <div :key="item.id" class="approval-item">
    <div class="flex flex-col min-w-0">
      <div class="item-title text-ellipsis">
        <a :href="hrefLink" target="_blank">{{ item.subject }}</a>
      </div>
      <div class="item-sub-title">
        {{ item.createdAt | datetime }}
        <div class="my-1">
          <FlotoUserAvatar size="small" :user-id="item.requesterId" />
          <span class="mx-1 requester-name">
            {{ item.approvalRequesterName }}
          </span>
        </div>
      </div>
    </div>
    <div class="flex items-center justify-end pl-4">
      <MTooltip>
        <template v-slot:trigger>
          <ApproveBtn
            :item="item"
            :approval-settings="approvalSettings"
            @refresh="handleRefresh"
          >
            <template v-slot:trigger="{ onUpdate: onApprove }">
              <span
                class="icon-button success mx-1"
                :disabled="isDisabled"
                @click="onApprove"
              >
                <MIcon name="check" size="lg" />
              </span>
            </template>
          </ApproveBtn>
        </template>
        {{ $t('approve') }}
      </MTooltip>
      <MTooltip>
        <template v-slot:trigger>
          <RejectBtn
            :item="item"
            :approval-settings="approvalSettings"
            @refresh="handleRefresh"
          >
            <template v-slot:trigger="{ onUpdate: onReject }">
              <span
                class="icon-button error mx-1"
                :disabled="isDisabled"
                @click="onReject"
              >
                <MIcon name="times" size="lg" />
              </span>
            </template>
          </RejectBtn>
        </template>
        {{ $t('reject') }}
      </MTooltip>
      <MTooltip>
        <template v-slot:trigger>
          <ReferBackBtn
            :item="item"
            :approval-settings="approvalSettings"
            @refresh="handleRefresh"
          >
            <template v-slot:trigger="{ onUpdate: onReferBack }">
              <span
                class="icon-button error mx-1"
                :disabled="isDisabled"
                @click="onReferBack"
              >
                <MIcon name="undo" size="small" />
              </span>
            </template>
          </ReferBackBtn>
        </template>
        {{ $t('refer_back') }}
      </MTooltip>
    </div>
  </div>
</template>

<script>
import ApproveBtn from '@modules/my-approval/components/approve-btn.vue'
import RejectBtn from '@modules/my-approval/components/reject-btn.vue'
import ReferBackBtn from '@modules/my-approval/components/refer-back-btn.vue'
import { LicenseComputed } from '@state/modules/license'
export default {
  name: 'PendingApprovalItem',
  components: { ApproveBtn, RejectBtn, ReferBackBtn },
  props: {
    item: { type: Object, required: true },
    approvalSettings: { type: Object, required: true },
  },
  computed: {
    ...LicenseComputed,
    hrefLink() {
      const link = this.$currentModule.getRoute('view-approval', {
        params: { id: this.item.approvalId },
      })
      return this.$router.resolve(link).href
    },
    isDisabled() {
      const currentModuleName =
        [
          this.$constants.ASSET_HARDWARE,
          this.$constants.ASSET_SOFTWARE,
          this.$constants.ASSET_NON_IT,
          this.$constants.ASSET_CONSUMABLE,
        ].indexOf(this.item.module) >= 0
          ? this.$constants.ASSET
          : this.item.module
      return this.availableModulesInLicense.indexOf(currentModuleName) === -1
    },
  },
  methods: {
    handleRefresh() {
      this.$emit('refresh')
    },
  },
}
</script>

<style lang="less" scoped>
.approval-item {
  @apply rounded py-2 px-4 flex mb-2 justify-between;

  background: var(--neutral-lightest);
  border-left: 4px solid var(--neutral-light);

  .item-title {
    font-size: 0.813rem;
    font-weight: 400;

    & a {
      color: var(--page-text-color);
    }
  }

  .item-sub-title {
    @apply text-neutral;

    font-size: 0.688rem;
    font-weight: 300;
  }
}

.icon-button {
  @apply flex items-center justify-center cursor-pointer;

  width: 1.552rem;
  height: 1.552rem;
  border-radius: 50%;

  &.success {
    color: var(--secondary-green);
    background-color: rgba(137, 197, 64, 0.2);
  }

  &.error {
    color: var(--secondary-red);
    background-color: rgba(240, 78, 62, 0.2);
  }
}

.requester-name {
  font-size: 13px;
}
</style>
